const animateCSS = require('./animate')

function init() {
    $(".menu-vertical .active>a").click()
}

function menuVertical() {
    $(".menu-vertical").off("click").on("click", ".menu-item>a", function () {
        const $parent = $(this).parent().parents(".menu-vertical");
        //kiểm tra đang chạy animation không
        if ($parent.attr("data-changing") == "1") return;

        $parent.find(".menu-item.active").removeClass("active")
        $parent.find(".menu-item-child.active").removeClass("active")
        $parent.find(".block").removeClass("block")
        $(this).parent().addClass("active");
        if($(this).parent().data("url") !== window.location.pathname) {
            $(this).parent().find(`[data-url='${window.location.pathname}']`).addClass('active')
        }
        $(this).parent().find('.menu-vertical-child').addClass('block')
        const $indicator = $parent.find(".indicator");
        const menuItemHeight = $(this).parent().height();
        const newTop = $(this).parent().position().top + (menuItemHeight - $indicator.height()) / 2
        $indicator.css({
            transform: `translateY(${newTop}px)`
        })
        //update content
        let id = $(this).parent().data("id");
        let childId = $(this).parent().find(`[data-url='${window.location.pathname}']`).data("id")

        if(childId && id !== childId) id = childId
        const $content = $(".menu-vertical-content")
        if ($content.length) {
            const $oldElement = $content.find(".active");
            const $newElement = $content.find(".content-" + id)
            $content.css({ minHeight: $newElement.height() })
            animateCSS($content.find(".animate__fadeIn").removeClass("active"), "fadeOut")
            animateCSS($newElement.addClass("active"), $oldElement.index() < $newElement.index() ? "fadeIn" : "fadeIn").then(() => { })
        }

        //custom for about page
        const newTitle = $(this).parent().data("title");
        const navActive = $('.nav-item.dropdown.active')
        if (newTitle) {
            navActive.find('.active').removeClass('active')
            navActive.find(`[data-href='${$(this).parent().data("url")}']`).addClass('active')
            document.title = newTitle;
            let url = $(this).parent().data("url")
            window.history.pushState('', newTitle, childId && id !== childId ? window.location.pathname : url);
        }
    })
}

function menuVerticalChild() {
    $(".menu-vertical-child").off("click").on("click", ".menu-item-child", function () {
        const $parent = $(this).parents(".menu-vertical-child");
        //kiểm tra đang chạy animation không
        if ($parent.attr("data-changing") == "1") return;

        $parent.find(".menu-item-child.active").removeClass("active")
        $(this).addClass("active");
        const $indicator = $parent.find(".indicator");
        const menuItemHeight = $(this).height();
        const newTop = $(this).position().top + (menuItemHeight - $indicator.height()) / 2
        $indicator.css({
            transform: `translateY(${newTop}px)`
        })
        //update content
        const id = $(this).data("id");
        const $content = $(".menu-vertical-content")
        if ($content.length) {
            const $oldElement = $content.find(".active");
            const $newElement = $content.find(".content-" + id)
            $content.css({ minHeight: $newElement.height() })
            animateCSS($content.find(".animate__fadeIn").removeClass("active"), "fadeOut")
            animateCSS($newElement.addClass("active"), $oldElement.index() < $newElement.index() ? "fadeIn" : "fadeIn").then(() => { })
        }

        //custom for about page
        const newTitle = $(this).data("title");
        const navActive = $('.nav-item.dropdown.active')
        if (newTitle) {
            navActive.find('.active').removeClass('active')
            navActive.find(`[data-href='${$(this).data("url")}']`).addClass('active')
            document.title = newTitle;
            window.history.pushState('', newTitle, $(this).data("url"));
        }
    })
}

$("document").ready(function () {
    menuVerticalChild();
    menuVertical();
    setTimeout(function () {
        init();
    }, 500)
})
